export default "__VITE_ASSET__BnKd4Uja__"